import React from 'react';
import { PropTypes } from 'prop-types';

const CustomTooltip = ({ active, payload, unitName, isSenate = false }) => {
  return active && payload && payload.length > 0 ? (
    <div
      className="custom-tooltip"
      style={{ borderLeft: `10px solid ${payload[0].payload.partyColor}` }}
    >
      <p className="name" style={{ color: payload[0].payload.partyColor }}>
        {payload[0].payload.partyAcronym}
      </p>
      {payload[0].payload.seats ? (
        <p className="esc">
          {Number(payload[0].payload.seats).toLocaleString('es')} {unitName}
        </p>
      ) : null}
      {payload[0].payload.votesPercent && !isSenate ? (
        <p className="percent">
          {Number(payload[0].payload.votesPercent).toLocaleString('es')} % votos
        </p>
      ) : null}
      {payload[0].payload.votes && !isSenate ? (
        <p className="percent">
          {Number(payload[0].payload.votes).toLocaleString('es')} votos
        </p>
      ) : null}
    </div>
  ) : null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(PropTypes.shape({})),
  unitName: PropTypes.string
};

CustomTooltip.defaultProps = {
  active: false,
  payload: [],
  unitName: ''
};

export default CustomTooltip;
